"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EntelLoader;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _CustomIconOrImage = _interopRequireDefault(require("../shared/CustomIconOrImage"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const LoaderWrapper = _styledComponents.default.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;
const Loader = _styledComponents.default.div`
  display: flex;
  overflow: clip;
`;
const LoaderContainer = _styledComponents.default.div`
  position: relative;
`;
const LoaderImgBox = _styledComponents.default.div`
  position: absolute;
  top: 18px;
  bottom: 18px;
  left: 18px;
  right: 18px;
  background-color: #002eff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 4px solid #ffffff;
`;
const spinKeyframe = (0, _styledComponents.keyframes)`
    from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
`;
const LoaderSpinners = _styledComponents.default.div`
  display: block;
  position: relative;
  width: ${props => props.size.ringSize};
  height: ${props => props.size.ringSize};
  border-radius: 50%;
  border: ${props => props.size.spinnersSize} solid transparent;
  border-top: ${props => props.size.spinnersSize} solid #002eff;
  -webkit-animation: ${spinKeyframe} 2s linear infinite;
  animation: ${spinKeyframe} 2s linear infinite;

  &:before,
  &:after {
    content: '';
    position: absolute;
    border-radius: 50%;
    border: ${props => props.size.spinnersSize} solid transparent;
  }

  &:before {
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    border-top-color: #00ffaf;
    -webkit-animation: ${spinKeyframe} 3s linear infinite;
    animation: ${spinKeyframe} 3.5s linear infinite;
  }

  &:after {
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: 8px;
    border-top-color: #fd6c98;
    -webkit-animation: ${spinKeyframe} 1.5s linear infinite;
    animation: ${spinKeyframe} 1.75s linear infinite;
  }
`;
const LoaderText = _styledComponents.default.h2`
  color: #0d0d0d;
  -webkit-letter-spacing: 0;
  -moz-letter-spacing: 0;
  -ms-letter-spacing: 0;
  letter-spacing: 0;
  font-weight: 200;
  text-align: center;
  margin-top: 10%;
  font-size: ${props => props.fontSize};
  line-height: ${props => props.lineHeight};
`;
const sizeConfigs = {
  1: {
    ringSize: '110px;',
    spinnersSize: '3px',
    fontSize: '20px;',
    lineHeight: '28px;',
    logoWidth: '35px',
    logoHeight: '27px'
  },
  2: {
    ringSize: '120px;',
    spinnersSize: '4px',
    fontSize: '28px;',
    lineHeight: '32px;',
    logoWidth: '39px',
    logoHeight: '31px'
  },
  3: {
    ringSize: '135px;',
    spinnersSize: '2px',
    fontSize: '50px;',
    lineHeight: '64px;',
    logoWidth: '45px',
    logoHeight: '37px'
  }
};
function EntelLoader(_ref) {
  let {
    text,
    srText,
    size = 2,
    titleTestId = null,
    indicatorTestId = null
  } = _ref;
  const sizeConfig = sizeConfigs[size] || sizeConfigs[3];
  const iconPath = '/assets/ws10/icons/entel/entel-icon.png';
  return /*#__PURE__*/_react.default.createElement(LoaderWrapper, null, /*#__PURE__*/_react.default.createElement(Loader, null, /*#__PURE__*/_react.default.createElement(LoaderContainer, null, /*#__PURE__*/_react.default.createElement(LoaderSpinners, {
    size: sizeConfig
  }), /*#__PURE__*/_react.default.createElement(LoaderImgBox, null, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    src: {
      sm: iconPath,
      md: iconPath,
      lg: iconPath
    },
    iconWidth: sizeConfig.logoWidth,
    iconHeight: sizeConfig.logoHeight,
    group: "system",
    size: 4,
    testId: indicatorTestId
  })))), srText && /*#__PURE__*/_react.default.createElement("span", {
    "aria-label": srText
  }), text && /*#__PURE__*/_react.default.createElement(LoaderText, {
    fontSize: sizeConfig.fontSize,
    lineHeight: sizeConfig.lineHeight,
    "data-test-id": titleTestId
  }, text));
}